import angular from 'angular';
import usersEmailSignature from './usersEmailSignature';

export default angular
  .module('components.usersEmailSignature', [])
  .component('usersEmailSignature', usersEmailSignature).name;
